import { render } from "./seatMapping.vue?vue&type=template&id=6794dc4e&scoped=true"
import script from "./seatMapping.vue?vue&type=script&lang=js"
export * from "./seatMapping.vue?vue&type=script&lang=js"

import "./seatMapping.vue?vue&type=style&index=0&id=6794dc4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6794dc4e"]])

export default __exports__